import {ProcessFlowchartSchemaMapperSpec} from 'processes/dao/ProcessSchemaDAO';
import {
  ProcessFlowchartOutputNode,
  ProcessFlowchartRootNode,
  ProcessFlowchartTaskNode,
} from 'processes/graph-builder-processes/flowchart-viz/ProcessFlowchartNodeDetailType';
import {
  ProcessTaskSchemaForGraphBuilderValidation,
  SchemaMapperConfig,
} from 'processes/graph-builder-processes/validation/ProcessGraphBuilderConstants';

export default function getSchemaMappersMappingToNode({
  taskNode,
  upstreamTaskNodes,
  fulfillingMapperConfigs,
  flowchartTaskSchema,
}: {
  taskNode: ProcessFlowchartTaskNode | ProcessFlowchartOutputNode;
  upstreamTaskNodes: Array<ProcessFlowchartTaskNode | ProcessFlowchartRootNode>;
  fulfillingMapperConfigs: Array<SchemaMapperConfig>;
  flowchartTaskSchema: ProcessTaskSchemaForGraphBuilderValidation;
}): Array<ProcessFlowchartSchemaMapperSpec> {
  const schemaMappers: Array<ProcessFlowchartSchemaMapperSpec> = [];
  const usedUpstreamNodeClientIds: Set<string> = new Set<string>();

  for (const upstreamTaskNode of upstreamTaskNodes) {
    if (usedUpstreamNodeClientIds.has(upstreamTaskNode.clientId)) {
      continue;
    }

    const mapperConfigsUsingUpstreamTaskNode = fulfillingMapperConfigs.filter((mapperConfig) =>
      mapperConfig.fromTaskSchemaIds.includes(upstreamTaskNode.taskSchemaId)
    );

    for (const targetSchemaMapperConfig of mapperConfigsUsingUpstreamTaskNode) {
      const schemaMapperUpstreamNodes =
        targetSchemaMapperConfig.fromTaskSchemaIds.length === 1
          ? [upstreamTaskNode]
          : upstreamTaskNodes.filter((upstreamTaskNode) =>
              targetSchemaMapperConfig.fromTaskSchemaIds.includes(upstreamTaskNode.taskSchemaId)
            );

      for (const schemaMapperUpstreamNode of schemaMapperUpstreamNodes) {
        usedUpstreamNodeClientIds.add(schemaMapperUpstreamNode.clientId);
      }
      schemaMappers.push({
        toNodeConfigClientId: taskNode.clientId,
        schemaMapperConfigClientId: targetSchemaMapperConfig.clientId,
        schemaMapperDependencies: schemaMapperUpstreamNodes.map((schemaMapperUpstreamNode) => ({
          fromNodeConfigClientId: schemaMapperUpstreamNode.clientId,
        })),
      });
    }
  }
  return schemaMappers;
}
